import { themeAlpine, themeQuartz } from 'ag-grid-community';

// The Theming API's Alpine palette differs from the legacy Alpine stylesheet the
// grids shipped with; these three values pin the legacy colours.
export const alpineTheme = themeAlpine.withParams({
  headerBackgroundColor: '#f8f8f8',
  borderColor: '#babfc7',
  rowBorder: { color: '#dde2eb' },
});

// Replaces the legacy Alpine header-colour classes that AlpineThemeGrid callers
// select through the headerBgColor prop.
export const alpineHeaderThemes = {
  white: alpineTheme.withParams({ headerBackgroundColor: 'white' }),
  'light-gray': alpineTheme,
};

export const quartzTheme = themeQuartz.withParams({
  wrapperBorder: false,
  headerRowBorder: false,
  rowBorder: { width: 2 },
  rowHeight: 70,
  headerHeight: 48,
  headerBackgroundColor: 'white',
  headerTextColor: '#637381',
});
